import {ClientCallType} from '@pexip/infinity';

import {CALL_TYPE} from '../constants';
import {isClientCallType} from './isClientCallType';
import {valueToNumber} from './valueToNumber';
import {getClientCallType} from './getClientCallType';

export const toClientCallType = (callType: string): ClientCallType => {
    const clientCallType = valueToNumber(callType);
    if (isClientCallType(clientCallType)) {
        return clientCallType;
    }

    const mappedCallType = getClientCallType(callType);
    if (mappedCallType) {
        return mappedCallType;
    }

    switch (callType) {
        case 'none': {
            return ClientCallType.None;
        }
        case 'presentation-only': {
            return ClientCallType.PresentationSendRecv;
        }
        case 'audioonly': {
            return ClientCallType.AudioSendRecvPresentationSendRecv;
        }
        case 'audiorecvonly': {
            return ClientCallType.AudioRecvPresentationSendRecv;
        }
        case 'audiosendonly': {
            return ClientCallType.AudioSendPresentationSendRecv;
        }
        case 'videoonly': {
            return ClientCallType.VideoSendRecvPresentationSendRecv;
        }
        case 'videorecvonly': {
            return ClientCallType.VideoRecvPresentationSendRecv;
        }
        case 'videosendonly': {
            return ClientCallType.VideoSendPresentationSendRecv;
        }
        case 'audiovideosendonly': {
            return ClientCallType.AudioSendVideoSendPresentationSendRecv;
        }
        case 'audiovideorecvonly': {
            return ClientCallType.AudioRecvVideoRecvPresentationSendRecv;
        }
        case 'video': {
            return ClientCallType.AudioSendRecvVideoSendRecvPresentationSendRecv;
        }
        default: {
            return CALL_TYPE;
        }
    }
};
